import { z } from "zod";

import { ChangeStartDateFormValues } from "./types";

export const INITIAL_VALUES_CHANGE_START_DATE_FORM: ChangeStartDateFormValues =
  {
    isStartImmediately: false,
    date: undefined,
  };

export const changeStartDateFormSchema = z
  .object({
    isStartImmediately: z.boolean(),
    date: z.date().optional(),
  })
  .superRefine(({ isStartImmediately, date }, ctx) => {
    if (!isStartImmediately && !date) {
      ctx.addIssue({
        code: "custom",
        message: "Date is a required field",
        path: ["date"],
      });
    }
  });
